import React, { ReactNode } from 'react';
import { Label } from '../ui/label';

export interface FormFieldItemProps {
  label: string;
  error?: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export const FormFieldItem: React.FC<FormFieldItemProps> = ({
  label,
  error,
  required,
  children,
  className = 'space-y-1.5',
}) => {
  return (
    <div className={className}>
      <Label className="text-xs font-medium text-foreground">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </Label>
      {children}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default FormFieldItem;
